var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"bookmark",class:{ active: _vm.active },attrs:{"name":_vm.light && !_vm.active ? 'bookmarks' : 'bookmarks2',"pointer":""},nativeOn:{"click":function($event){return _vm.toggle($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }